/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { css } from '@emotion/css';
import React, { MouseEvent } from 'react';
import { reveal } from './keyframe-animations';
interface ModalProps {
  onOutsideClick?: (ev?: MouseEvent) => void;
}

export const Modal: React.FC<ModalProps> = ({ onOutsideClick, children }) => {
  const interceptClickEvent = (ev: MouseEvent) => ev.stopPropagation();

  const modalStyles = css`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(rgba(245, 236, 202, 0.75) 16%, transparent 0),
      radial-gradient(rgba(245, 236, 202, 0.75) 16%, transparent 0), rgba(237, 225, 184, 0.75);
    background-position: 0 0, 12px 12px;
    background-size: 24px 24px;
    z-index: 1000;

    .dialog {
      display: flex;
      flex-direction: column;
      width: 90%;
      max-width: 480px;
      max-height: 90%;
      background: #f5f1e3;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
      border-radius: 48px;
      opacity: 0;
      visibility: hidden;
      transform: scale(0.95, 0.95);
      animation: 0.2s cubic-bezier(0.17, 0.89, 0.56, 1.72) ${reveal} both;
      animation-delay: 0.1s;
      /* Disable gray-color highlight for iOS Safari */
      -webkit-tap-highlight-color: transparent;
      @media (prefers-reduced-motion: reduce) {
        animation-delay: -1ms;
        animation-duration: 1ms;
      }
    }
  `;

  return (
    <div className={modalStyles} onClick={onOutsideClick}>
      <div className="dialog" onClick={interceptClickEvent}>
        {children}
      </div>
    </div>
  );
};
